module.exports = __webpack_public_path__ + "static/media/cg2.f1a683fe.jpg";